<template>
  <div class="artwork-filter-menu d-flex align-center">
    <v-menu v-model="menu" offset-y :close-on-content-click="false" min-width="340">
      <template v-slot:activator="{ on }">
        <v-btn small icon color="black" dark v-on="on" class="mx-2">
          <v-icon small>filter_list</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="py-2">
          <strong>Filter artworks</strong>
          <v-spacer></v-spacer>
          <v-btn small flat :disabled="active.length === 0" @click="clearAll">Clear all</v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <template v-for="group in groups">
          <v-subheader :key="`${group.id}-heading`" class="text-uppercase font-weight-bold">
            {{ group.label }}
          </v-subheader>
          <v-list-tile
            v-for="option in group.options"
            :key="`${group.id}-${option.id}`"
            @click="toggle(group.id, option.id)"
          >
            <v-list-tile-action>
              <v-checkbox
                :input-value="isSelected(group.id, option.id)"
                color="black"
                @click.stop="toggle(group.id, option.id)"
              ></v-checkbox>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ option.label }}</v-list-tile-title>
              <v-list-tile-sub-title v-if="option.section">{{ option.section }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider :key="`${group.id}-divider`"></v-divider>
        </template>
      </v-card>
    </v-menu>

    <div v-if="active.length" class="d-flex align-center flex-wrap">
      <v-chip
        v-for="filter in active"
        :key="`${filter.groupId}-${filter.id}`"
        small
        close
        @input="remove(filter.groupId, filter.id)"
      >
        {{ filter.section ? filter.section + ': ' : '' }}{{ filter.label }}
      </v-chip>
    </div>
    <span v-else class="subheading">All</span>
  </div>
</template>

<script>
import { artworkFilterGroups, activeArtworkFilters } from './artworkFilterGroups'

export default {
  props: {
    value: { type: Object, required: true },
  },
  data() {
    return {
      menu: false,
      groups: artworkFilterGroups,
    }
  },
  computed: {
    active() {
      return activeArtworkFilters(this.value)
    },
  },
  methods: {
    isSelected(groupId, optionId) {
      return (this.value[groupId] || []).includes(optionId)
    },
    toggle(groupId, optionId) {
      const next = { ...this.value }
      const selected = [...(next[groupId] || [])]
      const index = selected.indexOf(optionId)
      if (index === -1) selected.push(optionId)
      else selected.splice(index, 1)
      next[groupId] = selected
      this.$emit('input', next)
    },
    remove(groupId, optionId) {
      if (this.isSelected(groupId, optionId)) this.toggle(groupId, optionId)
    },
    clearAll() {
      const cleared = {}
      this.groups.forEach(group => {
        cleared[group.id] = []
      })
      this.$emit('input', cleared)
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/artworks/ArtworkFilterMenu.vue